<template>
    <div style="">
        <div style="height:50px; background-color: rgba(0,0,0,0.3);"></div>
        <div style="flex:1; background-color: rgba(0,0,0,0.3);">
            <div style="height:100%; background-color:white; border-top-left-radius: 12px; border-top-right-radius:12px;">
                <div style="height:55px; display:flex; align-items: center;">
                    <div style="width:60px;height:100%; display:grid; place-items: center; color:#808080; font-size:16px; font-weight:bold;" @click="() => {$GlobalStore.closeLastModal()}">닫기</div>
                    <div style="flex:1;"></div>
                    <div style="width:60px;"></div>
                </div>
                <div style="flex:1; padding:20px;">
                    <div style="text-align:center;margin-top:26px;">
                        <div style="color:#210F03; font-size:32px; font-weight:bold;">전화번호로 계정 찾기</div>
                        <div style="color:#210F03; font-size:16px; margin-top:8px;">기존에 가입된 번호로 계정을 찾을 수 있습니다.</div>
                    </div>
                    <div style="margin-top:40px;">
                        <div style="color:#210F03; font-size:14px;">전화번호</div>
                        <div style="border-radius:12px; background-color: #F5F5F5; margin-top:5px;">
                            <div class="input_wrap">
                                <input type="tel" ref="phoneInput" v-model="phone" class="input" placeholder="휴대폰 번호 입력" maxlength="13" @click="select($event)">
                            </div>

                            <template v-if="isSendAuthNumber">
                                <div class="input_wrap">
                                    <input ref="authNumber" type="tel" class="input" v-model="authNumber" placeholder="인증번호를 입력하세요." maxlength="6" >
                                </div>
                                <div style="display:flex; height:44px;align-items: center; padding:0px 12px;">
                                    <div style="flex:1; color:#808080; font-size:12px;">인증번호가 오지 않았나요?</div>
                                    <div style="color:var(--color-main); font-size:12px; " @click="sendAuthNumber">인증번호 다시 받기</div>
                                </div>
                            </template>
                        </div>

                        <div v-if="!isSendAuthNumber" class="btn" style="" @click="sendAuthNumber">인증번호 보내기</div>

                        <div v-if="isSendAuthNumber" class="btn" style="" @click="findAccount">계정 찾기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {LOGIN_PLATFORM} from "../../Constants";

    export default {
        name: "FindAccount",
        props: {
            completeAction: {
                type: Function,
                default: () => {}
            }
        },
        components: {},
        data(){
            return {
                LOGIN_PLATFORM : LOGIN_PLATFORM,
                phone : '',
                isSendAuthNumber : false,
                authNumber : '',
            }
        },
        methods : {
            select(e){
                e.currentTarget.select();
            },
            async sendAuthNumber(){
                if(!this.phone && this.phone.length !== 13){
                    this.$GlobalStore.showAlert('휴대폰번호를 입력해주세요.');
                    return;
                }

                const parameters = {};
                parameters.phone = this.phone;
                parameters.duple = '0';

                const res = await this.$Axios.post('/api/auth/number', parameters);
                if(res.data.code === 0){
                    this.isSendAuthNumber = true;
                    this.$nextTick(() => {
                        this.$refs.authNumber.focus()
                    })
                }else {
                    alert(res.data.msg);
                }
            },
            async findAccount(){
                if(!this.isSendAuthNumber){
                    this.$GlobalStore.showAlert('인증을 해주세요.');
                    return;
                }

                if(this.authNumber.length !== 6){
                    this.$GlobalStore.showAlert('인증번호를 입력해주세요.');
                    return;
                }

                const parameters = {};
                parameters.authNumber = this.authNumber;
                parameters.phone = this.phone;
                const res = await this.$Axios.post('/api/auth/find/account', parameters);
                if(res.data.code === 0){
                    this.$GlobalStore.closeLastModal();
                    this.$GlobalStore.addModal('FindAccount2', {transitionName : 'bottom', isModalBackTransparent : true, accountInfo : res.data.accountInfo});
                }else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
        },
        mounted(){
            this.$Util.setPhoneFormatter(this.$refs.phoneInput);

            //테스트용
            // this.$GlobalStore.addModal('FindAccount2', {transitionName : 'bottom', isModalBackTransparent : true, accountInfo :
            // null
                    // {platform : 2, reg_date : '2024-05-03 13:55:00', id : 'hagsulsa@naver.com'}
            // });
        },
        created(){
            this.sendAuthNumber = this.$Once(this.sendAuthNumber);
        }
    }
</script>

<style scoped>
    .round_btn{
    font-size:20px; padding:10px 0px; text-align:center; width: 150px; border:1px solid #ff6100; display:inline-block; border-radius:21px; font-weight:bold; color:#ff6100;

    }
    .input_wrap{padding:10px 0px;}
    .input{
        color:#210F03; width:100%;
      font-size:16px;padding:0px 12px; border:0px; outline: none;
        background-color: transparent;
    }
    .input::placeholder {
        color:#BBBBBB;
    }
    .label {
        font-size:14px; font-weight:bold; margin-top:50px; color:#656565;
    }

    .btn{margin-top:20px; background-color:#210f03; color:white; height:44px; border-radius:12px; font-weight:bold; font-size:14px; display:grid; place-items: center;}
</style>